import axios from '@/axios/axios';
import { directStatus } from "@/data/constances";

export default {
  namespaced: true,
  state: {
    directMatchingHistoryList: [],
    selectedDirectHistoryMatching: {},
    statistic: {
      all: 0,
      pending: 0,
      approve: 0,
      reject: 0,
    },
  },
  actions: {
    loadAllDirectMatchingHistory({ commit }) {
      return axios
        .get('/api/matching/direct/history/all')
        .then((response) => {
          if (response.status == 200) {
            commit('setDirectMatchingHistoryList', response.data)
            return Promise.resolve(response)
          }

          return Promise.reject(response.message)
        })
        .catch((error) => {
          console.log(error)
          return Promise.reject(error)
        })
    },
    loadDirectMatchingHistoryByStatus({ commit, dispatch }, params) {
      if (!params.status) {
        dispatch('loadAllDirectMatchingHistory')
        return
      }
      return axios
        .get('/api/matching/direct/history/get-by-status', { params })
        .then((response) => {
          if (response.status == 200) {
            commit('setDirectMatchingHistoryList', response.data)
            return Promise.resolve(response)
          }

          return Promise.reject(response.message)
        })
        .catch((error) => {
          console.log(error)
          return Promise.reject(error)
        })
    },
    getDirectMatchingHistoryDetail({ commit }, idx) {
      return axios
        .get('/api/matching/direct/history/get', {
          params: { idx },
        })
        .then((response) => {
          if (response.status == 200) {
            commit('setSelectedDirectMatchingHistory', response.data)
            return Promise.resolve(response)
          } else {
            commit('setSelectedDirectMatchingHistory', {})
          }

          return Promise.reject(response.message)
        })
        .catch((error) => {
          console.log(error)
          return Promise.reject(error)
        })
    },
    getDirectMatchingStatistic({ commit }) {
      Promise.all([
        axios.get('/api/matching/direct/history/count-status', { params: { status: directStatus.PENDING } }),
        axios.get('/api/matching/direct/history/count-status', { params: { status: directStatus.APPROVED } }),
        axios.get('/api/matching/direct/history/count-status', { params: { status: directStatus.REJECT } }),
      ]).then((values) => {
        let data = {
          all: 0,
          pending: 0,
          approve: 0,
          reject: 0,
        }

        if (values[0]?.status == 200) data.pending = values[0].data
        if (values[1]?.status == 200) data.approve = values[1].data
        if (values[2]?.status == 200) data.reject = values[2].data

        data.all = data.pending + data.approve + data.reject

        commit('setDirectMatchingStatistic', data)

      })
    },
  },
  mutations: {
    setDirectMatchingHistoryList(state, payload) {
      state.directMatchingHistoryList = payload
    },
    setSelectedDirectMatchingHistory(state, payload) {
      state.selectedDirectHistoryMatching = payload
    },
    setDirectMatchingStatistic(state, payload) {
      state.statistic = payload
    },
  }
}
